import { render, staticRenderFns } from "./PatentAnnuityStatusList.vue?vue&type=template&id=ca4319fa&"
import script from "./PatentAnnuityStatusList.vue?vue&type=script&lang=js&"
export * from "./PatentAnnuityStatusList.vue?vue&type=script&lang=js&"
import style0 from "./PatentAnnuityStatusList.vue?vue&type=style&index=0&id=ca4319fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports